export default {"src":"/_next/static/media/maaran_colour_black_with tag.5dc911b9.svg","height":781,"width":3685,"blurWidth":0,"blurHeight":0};